import React from 'react';
import styled from '@emotion/styled';

import { Colors } from '../constants';

namespace Article {
  const Container = styled.div`
    font-family: georgia, 'Times New Roman', times, serif;
    color: ${Colors.Text.Faint.base};

    display: flex;
    flex-direction: column;

    max-width: 42rem;

    & + & {
      margin-top: 3.5rem;
      padding-top: 3rem;
      border-top: 1px solid ${Colors.Container.border};
    }
  `;

  const TitleContainer = styled.div`
    margin-top: 0.25em;
  `;

  const TitleInner = styled.a`
    text-decoration: none;

    font-size: 2rem;
    font-weight: 500;
    line-height: 1.25;
    letter-spacing: -0.015em;
    color: ${Colors.Text.base};

    &:hover {
      color: ${Colors.Text.hover};
    }
  `;

  const TitleInnerNoLink = styled.div`
    font-size: 2rem;
    font-weight: 500;
    line-height: 1.25;
    letter-spacing: -0.015em;
    color: ${Colors.Text.base};
  `;

  interface TitleProps {
    href?: string;
    children: React.ReactNode;
  }
  function Title({ href, children }: TitleProps) {
    return (
      <TitleContainer>
        {href === undefined ? <TitleInnerNoLink>{children}</TitleInnerNoLink> : <TitleInner href={href}>{children}</TitleInner>}
      </TitleContainer>
    )
  }

  const Subtitle = styled.div`
    margin-top: 0.5em;
    margin-bottom: 1.25em;

    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 0.01em;
    color: ${Colors.Text.Faint.base};
  `;

  const Body = styled.div`
    line-height: 1.7;
    font-size: 17px;

    a {
      color: ${Colors.Text.base};
      text-decoration: underline;
      text-underline-offset: 2px;
      text-decoration-thickness: 1px;

      &:hover {
        color: ${Colors.Text.hover};
      }

      &:active {
        color: ${Colors.Text.active};
      }
    }

    img {
      margin-top: 0.5em;
      margin-bottom: 0.5em;
    }
  `;

  interface Props {
    title: string;
    subtitle?: string;
    path?: string;
    postedAt?: Date;
    children: React.ReactNode;
  }
  export function T({ title, subtitle, path, postedAt, children }: Props) {
    return (
      <Container key={title}>
        <Title href={path}>{title}</Title>

        {subtitle === undefined || subtitle === '' ? null : <Subtitle>{subtitle}</Subtitle>}
        {postedAt === undefined ? null : <Subtitle>{postedAt.toLocaleString('default', { month: 'long' })} {postedAt.getDate()}, {postedAt.getFullYear()}</Subtitle>}

        <Body>
          {children}
        </Body>
      </Container>
    )
  }

  export const P = styled.p`
    margin-top: 0;
    margin-bottom: 1.4em;
  `;

  export const BR = styled.div`
    height: 0.5em;
  `;

  export const Header = styled.div`
    display: block;
    margin-top: 0.5em;
    margin-bottom: 0.75em;

    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.35;
    color: ${Colors.Text.base};
  `;

  const ImageContainer = styled.div`
    width: 100%;

    display: flex;
    flex-direction: column;
    text-align: center;

    margin: 1.5em 0;

    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    color: ${Colors.Text.Faint.base};
  `;

  const ImageInner = styled.div`
    width: 100%;
    margin-bottom: 0.6em;
  `;

  interface ImageProps {
    src: string;
    alt: string;
  }
  export function Image({ src, alt }: ImageProps) {
    return (
      <ImageContainer>
        <ImageInner>
          <img src={src} alt={alt} width="100%" />
        </ImageInner>

        {alt}
      </ImageContainer>
    )
  }
}

export default Article;
